export const MAX_WIDGET_TITLE_LENGTH = 50
export const MAX_WIDGET_SUBTITLE_LENGTH = 280

// useWidgetData hand-counts one option-label lookup hook per breakdown row (hooks can't loop).
// Raising this cap without adding a hook there leaves the extra row's buckets showing raw ids.
export const MAX_BREAKDOWNS = 2

export const CHART_LIMIT_OPTIONS = [12, 24, 42] as const
export const DEFAULT_CHART_LIMIT = CHART_LIMIT_OPTIONS[0]
export const MIN_CHART_LIMIT = Math.min(...CHART_LIMIT_OPTIONS)
export const MAX_CHART_LIMIT = Math.max(...CHART_LIMIT_OPTIONS)
// A bucketed breakdown draws every bucket instead of taking a top-N limit, so this caps how many groups
// one can draw, whether numeric or by date, at the most a text breakdown can be set to show.
export const MAX_BUCKETS = MAX_CHART_LIMIT
